import { Nav, Stack } from 'react-bootstrap';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import ScoringSwitch from '../../../../../common/components/ScoringSwitch';
import { useState, useEffect } from 'react';

const HrScoringNavigation = (props) => {
  const [activeMode, setActiveMode] = useState(1); // 1 = table, 2 = graph
  const navigate = useNavigate();
  const location = useLocation();
  const { t, employeeCanViewTeam } = props;
  const currentURL = location.pathname;

  const navigateArray = [
    {
      label: t('page.hr_scoring_own_tab'),
      link: `/hr-scoring/own/table`,
      identity: `/own`
    }
  ];

  if (employeeCanViewTeam === true) {
    navigateArray.push({
      label: t('page.hr_scoring_team_tab'),
      link: `/hr-scoring/team/table`,
      identity: '/team'
    });
  }

  // Detect TABLE or GRAPH mode
  useEffect(() => {
    if (currentURL.includes("/graph")) {
      setActiveMode(2);
      localStorage.setItem("hrScoringMode", 2);
    } 
    else if (currentURL.includes("/table")) {
      setActiveMode(1);
      localStorage.setItem("hrScoringMode", 1);
    }
  }, [currentURL]);

  const handleModeChange = (value) => {
    setActiveMode(value);
    localStorage.setItem("hrScoringMode", value);

    const isTeam = currentURL.includes("/team");
    const base = isTeam ? "/hr-scoring/team" : "/hr-scoring/own";

    navigate(`${base}/${value === 1 ? 'table' : 'graph'}`);
  };

  return (
    <>
      <Stack className="attendance-nav-wrapper d-flex flex-wrap row-gap-4 flex-md-row justify-content-between align-items-md-center">
        <div className="d-flex flex-column flex-sm-row row-gap-4 align-items-sm-center w-100">
          
          <div className="page-title">
            <h1 className="title">{t('page.hr_scoring_list_label')}</h1>
          </div>

          {/* Tabs */}
          <Nav className="custom-tabs">
            {navigateArray.map((navObj, index) => {
              const targetLink =
                activeMode === 2
                  ? navObj.link.replace("/table", "/graph")
                  : navObj.link;

              return (
                <Nav.Item key={index}>
                  <NavLink
                    className={
                      currentURL.includes(navObj.identity)
                        ? 'active-tab nav-link'
                        : 'nav-link'
                    }
                    to={targetLink}
                  >
                    {navObj.label}
                  </NavLink>
                </Nav.Item>
              );
            })}
          </Nav>

          {/* Graph/Table Switch */}
          <ScoringSwitch
            className='ms-4 ms-md-auto me-md-4'
            onChange={handleModeChange}
            value={activeMode}
          />

        </div>
      </Stack>

      <Outlet context={{ activeMode }} />
    </>
  );
};

HrScoringNavigation.propTypes = {
  t: PropTypes.func,
  employeeCanViewTeam: PropTypes.bool
};

export { HrScoringNavigation };
